import React from 'react'
import { func } from 'prop-types'
import VideoProp from 'utils/prop_types/VideoProp'

import PlayButton from 'components/atoms/SVGIcons/PlayButton'
import Ellipsis from 'components/atoms/Ellipsis'

import Relazsizes from 'relazsizes'

const VideoCard = ({ video, onClick }) => {
  const videoId = video.source.substring(video.source.lastIndexOf('/') + 1)
  const thumbnail = video.thumbnail || `https://img.youtube.com/vi/${videoId}/0.jpg`
  return (
    <div id="videos" className="video-card" onClick={() => onClick(video.source, video.title)}>
      <div className="video-card__thumbnail">
        <Relazsizes
          dataSrc={thumbnail}
          className="video-card__thumbnail-img"
          alt={video.title}
        />
        <div className="video-card__play-btn">
          <PlayButton width={40} height={40}/>
        </div>
      </div>
      {
        video.title &&
        <div className="video-card__title" title={video.title}>
          <Ellipsis
            component="h4"
            height={60}
            text={video.title}
          />
        </div>
      }
      {
        video.description &&
        <div className="video-card__desc">
          <Ellipsis
            text={video.description}
            height={72}
            markdown
          />
        </div>
      }
      <style jsx>
        {`
          .video-card {
            cursor: pointer;
            margin-bottom: 16px;
            &__title {
              :global(h4) {
                font-weight: bold;
                font-size: 16px;
                color: #1a344f;
                margin: 16px 0;
                line-height: 1.5;
              }
            }
            &__thumbnail {
              width: 100%;
              border-radius: 8px;
              position: relative;
              max-height: 146px;
            }
            :global(&__thumbnail-img) {
              width: 100%;
              border-radius: 8px;
              max-height: 146px;
            }
            &__play-btn {
              border-radius: 8px;
              position: absolute;
              background-color: rgba(0,0,0,.5);
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            &__desc {
              :global(p), :global(span) {
                font-size: 14px;
                line-height: 2;
                color: #485c77;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

VideoCard.propTypes = {
  video: VideoProp,
  onClick: func,
}

export default VideoCard
